import PropTypes from 'prop-types';
import React, { memo, useCallback, useEffect, useState } from 'react';
import arrayMove from '../../../utils/arrayMove';

import { SortableList } from './SortableList';
import { useEntityEventContext } from '../../../contexts/EntityEventContext';

const CompanyContactsLabels = ({ canEditData, contacts, reorderContacts, ...rest }) => {
  const { entityId } = useEntityEventContext();
  const [items, setItems] = useState(() => contacts.toJS());

  useEffect(() => {
    setItems(contacts.toJS());
  }, [contacts]);

  const handleSortEnd = useCallback(
    ({ oldIndex, newIndex }) => {
      const reordered = arrayMove(items, oldIndex, newIndex);

      setItems(reordered);

      const conts = contacts.map((c, i, cs) => cs.find(contact => reordered[i].id === contact.get('id')));

      reorderContacts(conts);
    },
    [items, contacts, reorderContacts],
  );

  return (
    <SortableList
      {...rest}
      canEditData={canEditData}
      contacts={contacts}
      disabled={!canEditData}
      distance={1}
      entityId={entityId}
      items={items}
      lockAxis="y"
      onSortEnd={handleSortEnd}
      reorderContacts={reorderContacts}
    />
  );
};

CompanyContactsLabels.propTypes = {
  canEditData: PropTypes.bool.isRequired,
};

export default memo(CompanyContactsLabels);
